import { mapActions, mapGetters } from "vuex";
import { globalLoader } from "@/helpers/variables";

import CategoryItem from "@/modules/pages/before-after/components/category-item/index.vue";
import BeforeAfterBreadcrumbs from "@/components/before-after-breadcrumbs/index.vue";

export default {
  name: "BeforeAfterPage",

  components: { CategoryItem, BeforeAfterBreadcrumbs },

  computed: {
    ...mapGetters({
      categories: "beforeAfter/categories",
    }),
  },

  methods: {
    ...mapActions({
      fetchCategories: "beforeAfter/FETCH_BEFORE_AFTER_CATEGORIES",
    }),
  },

  async created() {
    try {
      globalLoader(true);
      await this.fetchCategories();
    } catch (e) {
      console.error("FETCH ERROR:", e);
    } finally {
      globalLoader(false);
    }
  },
};
